import { useState } from 'react';
import { useSelector } from 'react-redux';
import { Text, Buttons, Inputs, FlexContainer } from '@taxdown/piccolo-web';
import { validations } from '@taxdown/papaya';
import { locizeNS } from 'Services/i18n';
import EventService from 'Services/events';
import StorageService from 'Services/storage';
import { history } from 'Store';
import { routeStateSelector } from 'Store/modules/router/selectors';
import { useTranslation } from 'Hooks/useTranslation';
import OneColLayout from 'Components/Layouts/OneColLayout';
import { routes } from 'Constants/routes';
import * as Styled from './styles';
import model from './model.json';
import { validateDate } from './utils';

const initialState = {
  name: '',
  fatherName: '',
  motherName: '',
  birthday: '',
};

const CalculateRfc = (): JSX.Element => {
  const [values, setValues] = useState(initialState);
  const [error, setError] = useState(false);
  const isPreviousYears = useSelector(routeStateSelector);
  const { t } = useTranslation(locizeNS.DG);

  const removeSpecialCharacters = (str: string): string => {
    return str
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-zA-Z0-9\s]/g, '');
  };

  const handleChange = (value: string, name: string): void => {
    if (name === 'birthday') {
      setError(!validateDate(value));
    }

    setValues(prev => {
      return {
        ...prev,
        [name]: name === 'birthday' ? value : removeSpecialCharacters(value).toUpperCase(),
      };
    });
  };

  const generateRfc = (): void => {
    const rfc = validations.Rfc.generateRfc(
      values.name,
      values.fatherName,
      values.motherName,
      values.birthday
    );
    EventService.formSubmitted({
      screenId: 'calculate-rfc',
      values: [
        {
          infoValues: {
            rfc,
            name: values.name,
            fatherName: values.fatherName,
            motherName: values.motherName,
            birthday: values.birthday,
          },
        },
      ],
    });
    StorageService.setItem('rfc', rfc);
    history.push(routes.DATAGATHERING_IDENTIFICATION_RFC, {
      rfc,
      products: isPreviousYears?.products,
    });
  };

  return (
    <OneColLayout>
      <FlexContainer direction="column" fullHeight fullWidth justify="center" align="center">
        <FlexContainer direction="column" fullHeight justify="space-between">
          <Styled.Container direction="column" gap="dimension_16" fullHeight>
            <Text type="headline" color="dark" size="S_M_M">
              {t('Dg.calculate.title')}
            </Text>
            <Text type="paragraphs" color="grey" size="M_M_M">
              {t('Dg.calculate.subtilte')}
            </Text>
            {model.map(item => (
              <Inputs.Text
                key={item.id}
                label={t(item.label)}
                placeholder={t(item.placeholder)}
                value={values[item.name].toUpperCase()}
                onChange={val => handleChange(val, item.name)}
              />
            ))}
            <Inputs.Date
              label={t('Dg.calculate.label.birthday')}
              value={values.birthday}
              name="birthday"
              onChange={e => handleChange(e, 'birthday')}
              hasError={error}
              errorMsg={t('Dg.calculate.error.birthday')}
            />
          </Styled.Container>
          <Styled.ButtonContainer align="center" justify="center">
            <Buttons.Classic
              label={t('DGRfc.CTA')}
              mode="primary"
              onClick={generateRfc}
              size="m"
              disabled={
                !values.birthday ||
                !values.name ||
                !values.fatherName ||
                !validateDate(values.birthday)
              }
            />
          </Styled.ButtonContainer>
        </FlexContainer>
      </FlexContainer>
    </OneColLayout>
  );
};

export default CalculateRfc;
